import React, { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { APPLY_SECTION_ID, scrollToApply } from "../utils/scroll";
import { arrowClass } from "../utils/buttonStyles";
import { track } from "../utils/tracking";

/** Sections where another primary CTA is already on screen. */
const HIDE_WHEN_VISIBLE = ["top", APPLY_SECTION_ID];
export function StickyBar() {
  const [hidden, setHidden] = useState(true);
  const visible = useRef(new Set<string>());
  const reduce = useReducedMotion();
  useEffect(() => {
    const targets = HIDE_WHEN_VISIBLE.map(id => document.getElementById(id)).filter((el): el is HTMLElement => el !== null);
    if (targets.length === 0) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) visible.current.add(entry.target.id);else visible.current.delete(entry.target.id);
      });
      setHidden(visible.current.size > 0);
    }, {
      threshold: 0.15
    });
    targets.forEach(t => observer.observe(t));
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-360" data-mp="38hcgnn3k5345">
      {!hidden && <motion.div initial={reduce ? {
      opacity: 0
    } : {
      y: "100%"
    }} animate={reduce ? {
      opacity: 1
    } : {
      y: 0
    }} exit={reduce ? {
      opacity: 0
    } : {
      y: "100%"
    }} transition={{
      duration: 0.25,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-ink/90 pb-[env(safe-area-inset-bottom)] backdrop-blur-md md:bg-ink/75" data-id="element-361" data-mp="38idt9w081xnz">
          <div className="page-container flex h-14 items-center justify-between gap-4 md:h-[52px]" data-id="element-362" data-mp="3rdknuwg4ro23">
            <p className="hidden font-ui text-[12px] font-bold uppercase tracking-[0.16em] text-cream md:block" data-id="element-363" data-mp="7auuhl6qyye">
              Solo 3 cupos · <span className="text-gold" data-id="element-364" data-mp="spew2aqz1fit">Programa Cliente Fundador</span>
            </p>
            <button type="button" onClick={() => {
          track("CTAClick", {
            source: "sticky"
          }, {
            custom: true
          });
          scrollToApply();
        }} className="group inline-flex h-12 w-full items-center justify-center gap-2 whitespace-nowrap rounded-[3px] bg-gold px-5 font-ui text-[14px] font-bold uppercase tracking-[0.02em] text-ink transition-[transform,box-shadow] duration-200 ease-out hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(255,183,0,0.25)] active:translate-y-0 active:shadow-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-ink md:h-9 md:w-auto md:text-[13px]" data-id="element-365" data-mp="12lnb48izj6tc">
              AGENDAR DIAGNÓSTICO
              <span className={arrowClass} aria-hidden="true" data-id="element-366" data-mp="4w263vxkvfc6">
                →
              </span>
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}